export default __webpack_public_path__ + "static/media/twitter_kod.a20123e3.webp";